// THIS FILE IS AUTO-GENERATED
// Contains the bioprocess workflow icons plus shared workbench controls.
import React from 'react';

export const WxbIconsData: Record<string, React.ReactNode> = {
  'close': (<>
    <path d="M6 6l12 12M18 6L6 18"/>
  </>),
  'chevron-left': (<>
    <path d="M15 18l-6-6 6-6"/>
  </>),
  'chevron-right': (<>
    <path d="M9 18l6-6-6-6"/>
  </>),
  'chevron-down': (<>
    <path d="M6 9l6 6 6-6"/>
  </>),
  'zoom-in': (<>
    <circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4M11 8v6M8 11h6"/>
  </>),
  'zoom-out': (<>
    <circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4M8 11h6"/>
  </>),
  'refresh': (<>
    <path d="M23 4v6h-6M1 20v-6h6"/>
    <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/>
  </>),
  'users': (<>
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
  </>),
  'play': (<>
    <polygon points="6 4 20 12 6 20 6 4"/>
  </>),
  'info': (<>
    <circle cx="12" cy="12" r="10"/>
    <path d="M12 16v-4M12 8h.01"/>
  </>),
  'gantt-bars': (<>
    <path d="M4 6h10M4 12h7M4 18h13"/>
  </>),
  'clock': (<>
    <circle cx="12" cy="12" r="10"/>
    <path d="M12 6v6l4 2"/>
  </>),
  'vial-thaw': (<>
    <path d="M9 2v3h6V2"/><path d="M8 5h8l-1 14a2 2 0 01-2 2h-2a2 2 0 01-2-2L8 5z"/><path d="M9 11h6"/><path d="M11 17h2"/>
  </>),
  'cell-line': (<>
    <circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5" fill="currentColor"/><path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4"/>
  </>),
  'shake-flask': (<>
    <path d="M7 3h10v3l-2 3v3a3 3 0 11-6 0V9L7 6V3z"/><circle cx="12" cy="14" r="0.6" fill="currentColor"/><circle cx="11" cy="11" r="0.6" fill="currentColor"/><circle cx="13" cy="12.5" r="0.6" fill="currentColor"/>
  </>),
  'seed-train': (<>
    <rect x="6" y="3" width="4" height="18" rx="0.5"/><rect x="14" y="3" width="4" height="18" rx="0.5"/><path d="M7 10h2M15 14h2"/>
  </>),
  'n-1-vessel': (<>
    <path d="M6 3h12v3a4 4 0 01-1 2.5L15 11v8a2 2 0 01-2 2h-2a2 2 0 01-2-2v-8L7 8.5A4 4 0 016 6V3z"/><path d="M9 13h6"/><circle cx="11" cy="16" r="0.5" fill="currentColor"/><circle cx="13" cy="17.5" r="0.5" fill="currentColor"/>
  </>),
  'bioreactor': (<>
    <rect x="6" y="3" width="12" height="4" rx="0.5"/><path d="M7 7v12a2 2 0 002 2h6a2 2 0 002-2V7"/><path d="M9 13h6"/><path d="M3 10v3M3 11.5h3"/><path d="M21 16v3M21 17.5h-3"/>
  </>),
  'media-tank': (<>
    <path d="M5 3h6v18H5z"/><path d="M13 5h6v14h-6z"/><path d="M7 7h2M7 11h2M15 9h2M15 13h2"/>
  </>),
  'gassing-O2': (<>
    <circle cx="6" cy="6" r="3"/><path d="M6 9v9"/><path d="M3 13c2 2 4 2 6 0s4-2 6 0 4 2 6 0"/>
  </>),
  'sampling': (<>
    <path d="M5 4h14"/><path d="M7 4l5 9 5-9"/><path d="M12 13v8"/><circle cx="12" cy="18" r="2"/>
  </>),
  'ph-probe': (<>
    <circle cx="12" cy="12" r="9"/><path d="M9 12c1-3 5-3 6 0M8 14h8"/><path d="M12 6v3M12 15v3"/>
  </>),
  'thermo-probe': (<>
    <path d="M12 2v6"/><path d="M9 8h6l1 3-2 9H10l-2-9 1-3z"/><path d="M10 14h4"/>
  </>),
  'perfusion': (<>
    <path d="M3 12c3 0 3-4 6-4s3 8 6 8 3-4 6-4"/><path d="M3 17h18"/>
  </>),
  'harvest': (<>
    <circle cx="12" cy="9" r="4"/><path d="M8 12l-3 9h14l-3-9"/><path d="M11 6c0-1 2-1 2 0"/>
  </>),
  'centrifuge': (<>
    <circle cx="12" cy="12" r="9"/><path d="M12 3a14 14 0 010 18M3 12h18"/><path d="M12 3v18" strokeDasharray="2 2"/>
  </>),
  'upstream-suite': (<>
    <path d="M5 21V9l7-6 7 6v12"/><path d="M5 13h14"/><path d="M9 21v-5h6v5"/>
  </>),
  'sub-incubator': (<>
    <rect x="3" y="6" width="14" height="12" rx="1"/><path d="M17 10h2a2 2 0 012 2v0a2 2 0 01-2 2h-2"/><path d="M7 12h6M7 15h4"/>
  </>),
  'clarification': (<>
    <path d="M3 4h18l-7 9v6l-4 2v-8z"/>
  </>),
  'chrom-column': (<>
    <rect x="7" y="3" width="10" height="18" rx="2"/><path d="M9 7h6M9 11h6M9 15h6M9 19h6"/>
  </>),
  'capture-protA': (<>
    <rect x="6" y="3" width="4" height="18" rx="1"/><rect x="14" y="3" width="4" height="18" rx="1"/><path d="M10 8h4M10 12h4M10 16h4"/>
  </>),
  'viral-inact': (<>
    <circle cx="12" cy="12" r="9"/><path d="M12 4v16"/><path d="M8 8l8 8M16 8l-8 8" strokeDasharray="2 2"/>
  </>),
  'polish-AEX': (<>
    <rect x="5" y="3" width="14" height="18" rx="1"/><path d="M5 9h14M5 15h14"/><path d="M9 6l3 0M9 12l3 0M9 18l3 0"/>
  </>),
  'polish-CEX': (<>
    <rect x="6" y="3" width="12" height="18" rx="1"/><path d="M6 8h12M6 13h12M6 18h12" strokeDasharray="1 2"/><path d="M2 12h2M20 12h2"/>
  </>),
  'uv-detector': (<>
    <path d="M3 12h4l3-7 4 14 3-7h4"/>
  </>),
  'uf-df-cassette': (<>
    <rect x="3" y="7" width="18" height="10" rx="1"/><path d="M3 12h18" strokeDasharray="1 2"/><path d="M7 7v10M11 7v10M15 7v10"/><path d="M2 9l-1 0M2 15l-1 0M22 9l1 0M22 15l1 0"/>
  </>),
  'tff-skid': (<>
    <circle cx="12" cy="12" r="9"/><path d="M3 12c3-3 6-3 9 0s6 3 9 0"/><path d="M3 12c3 3 6 3 9 0s6-3 9 0"/>
  </>),
  'diafilter': (<>
    <rect x="4" y="4" width="16" height="16" rx="1"/><path d="M4 9h16M9 4v16M4 14h16M14 4v16"/>
  </>),
  'viral-filter': (<>
    <path d="M5 3h14v6l-3 4v8H8v-8L5 9z"/><path d="M5 9h14"/><circle cx="12" cy="15" r="0.6" fill="currentColor"/><circle cx="10" cy="18" r="0.6" fill="currentColor"/>
  </>),
  'buffer-skid': (<>
    <rect x="3" y="3" width="18" height="6" rx="1"/><rect x="3" y="15" width="18" height="6" rx="1"/><path d="M9 9v6M15 9v6"/>
  </>),
  'conductivity': (<>
    <circle cx="12" cy="12" r="9"/><path d="M9 12a3 3 0 016 0c0 2-3 2-3 4"/><path d="M12 18h.01"/>
  </>),
  'inline-mix': (<>
    <path d="M4 8h16v8H4z"/><path d="M4 12h16" strokeDasharray="1 2"/><circle cx="8" cy="12" r="0.6" fill="currentColor"/><circle cx="12" cy="12" r="0.6" fill="currentColor"/><circle cx="16" cy="12" r="0.6" fill="currentColor"/>
  </>),
  'fill-prep': (<>
    <path d="M6 3h12v6l-2 2v8a2 2 0 01-2 2h-4a2 2 0 01-2-2v-8L6 9z"/><path d="M9 14h6"/>
  </>),
  'downstream-line': (<>
    <rect x="3" y="9" width="18" height="6" rx="1"/><path d="M7 9V6a2 2 0 014 0M13 9V6a2 2 0 014 0"/><path d="M3 12h18" strokeDasharray="1 2"/>
  </>),
  'wfi': (<>
    <circle cx="12" cy="12" r="9"/><path d="M12 6v6l4 2"/>
  </>),
  'weigh': (<>
    <path d="M3 18h18"/><path d="M5 18l3-9h8l3 9"/><path d="M12 9V5"/><path d="M9 5h6"/>
  </>),
  'dispense': (<>
    <path d="M5 3v6l3 3v9h8v-9l3-3V3z"/><path d="M5 9h14"/><path d="M10 16h4"/>
  </>),
  'mix-tank': (<>
    <rect x="6" y="3" width="12" height="6" rx="1"/><path d="M7 9v10a2 2 0 002 2h6a2 2 0 002-2V9"/><circle cx="12" cy="14" r="2"/><path d="M12 11v3"/>
  </>),
  'impeller': (<>
    <circle cx="12" cy="12" r="6"/><path d="M9 12h6M12 9v6"/><circle cx="12" cy="12" r="2" fill="currentColor"/><path d="M12 4v2M12 18v2M4 12h2M18 12h2"/>
  </>),
  'buffer-prep': (<>
    <path d="M12 3v3"/><path d="M9 6h6"/><path d="M9 6l-3 12a3 3 0 003 3h6a3 3 0 003-3l-3-12"/><path d="M8 14c2-1 4 1 6 0s4-1 4 0"/>
  </>),
  'hydrate': (<>
    <circle cx="12" cy="12" r="9"/><path d="M8 13c2 2 6 2 8 0"/><circle cx="9" cy="9" r="0.8" fill="currentColor"/><circle cx="15" cy="9" r="0.8" fill="currentColor"/>
  </>),
  'sterilize': (<>
    <circle cx="12" cy="12" r="9"/><path d="M9 12h6"/><path d="M12 9v6" strokeDasharray="1 1"/><path d="M5 5l14 14" strokeDasharray="2 2"/>
  </>),
  'autoclave': (<>
    <rect x="4" y="6" width="16" height="12" rx="1"/><path d="M8 6V3M16 6V3"/><path d="M4 11h16"/><path d="M8 14h2M14 14h2"/>
  </>),
  'concentrate': (<>
    <rect x="6" y="3" width="12" height="18" rx="2"/><path d="M9 8h6M9 12h6M9 16h6" strokeDasharray="1 2"/><circle cx="12" cy="6" r="0.8" fill="currentColor"/>
  </>),
  'recipe': (<>
    <path d="M3 7h18M3 12h18M3 17h18"/><circle cx="6" cy="7" r="1.2" fill="currentColor"/><circle cx="14" cy="12" r="1.2" fill="currentColor"/><circle cx="9" cy="17" r="1.2" fill="currentColor"/>
  </>),
  'hold-vessel': (<>
    <path d="M6 3h12l-1 5h-10z"/><path d="M7 8l1 13h8l1-13"/><path d="M10 12h4"/>
  </>),
  'flow-divert': (<>
    <path d="M4 12h6l-3-4M4 12l3 4"/><path d="M14 8h6l-3-4M14 16h6l-3 4"/><circle cx="12" cy="12" r="2"/>
  </>),
  'hold-time': (<>
    <circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 1"/><path d="M3 12h2M19 12h2"/>
  </>),
  'scale-readout': (<>
    <path d="M5 3h14v8a7 7 0 01-14 0z"/><path d="M5 11h14"/><path d="M9 21h6"/><path d="M12 18v3"/>
  </>),
  'cip-system': (<>
    <path d="M3 8h2l3 12h8l3-12h2"/><path d="M8 4h8v4H8z"/>
  </>),
  'receipt': (<>
    <path d="M3 7l9-4 9 4-9 4-9-4z"/><path d="M3 7v10l9 4 9-4V7"/><path d="M12 11v10"/>
  </>),
  'warehouse': (<>
    <rect x="3" y="4" width="18" height="16" rx="1"/><path d="M3 10h18M9 4v16"/>
  </>),
  'kanban': (<>
    <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>
  </>),
  'barcode': (<>
    <rect x="3" y="6" width="18" height="12" rx="1"/><path d="M6 6v12M9 6v12M13 6v12M17 6v12"/>
  </>),
  'qr-trace': (<>
    <rect x="3" y="3" width="6" height="6"/><rect x="15" y="3" width="6" height="6"/><rect x="3" y="15" width="6" height="6"/><path d="M13 13h2v2h-2zM17 13h2v2h-2zM13 17h2v2h-2zM17 17h2v2h-2z"/>
  </>),
  'quarantine': (<>
    <path d="M12 2v6"/><path d="M9 5l3 3 3-3"/><circle cx="12" cy="14" r="6"/><path d="M12 11v3l2 1"/>
  </>),
  'released': (<>
    <circle cx="12" cy="12" r="9"/><path d="M9 12l2 2 4-5"/>
  </>),
  'cold-chain': (<>
    <circle cx="12" cy="12" r="9"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4"/><path d="M6 6l3 3M15 15l3 3M6 18l3-3M15 9l3-3"/>
  </>),
  'rejected': (<>
    <rect x="4" y="4" width="16" height="16" rx="1"/><path d="M9 9l6 6M15 9l-6 6"/><path d="M4 4l4 4M16 16l4 4"/>
  </>),
  'expiry': (<>
    <circle cx="12" cy="12" r="9"/><path d="M12 8v5l3 1.5"/><path d="M16 5l3-2M5 19l-2 2"/>
  </>),
  'shipment': (<>
    <rect x="2" y="7" width="14" height="10" rx="1"/><path d="M16 10h4l2 3v4h-6"/><circle cx="6" cy="19" r="2"/><circle cx="18" cy="19" r="2"/>
  </>),
  'lot': (<>
    <path d="M5 8l7-4 7 4-7 4-7-4z"/><path d="M5 8v8l7 4 7-4V8"/><path d="M9 18l-2-2"/>
  </>),
  'raw-mat': (<>
    <path d="M4 3v4l3 3v8a2 2 0 002 2h6a2 2 0 002-2v-8l3-3V3z"/><path d="M4 7h16"/><path d="M9 14h6"/>
  </>),
  'powder': (<>
    <path d="M12 2v4"/><path d="M9 6h6l2 4-5 12h-0L7 10z"/><path d="M9 14h6"/>
  </>),
  'reagent': (<>
    <rect x="6" y="6" width="12" height="14" rx="1"/><path d="M9 6V4h6v2"/><path d="M10 11h4M10 15h4"/>
  </>),
  'pallet': (<>
    <path d="M4 4h16v6H4z"/><path d="M4 14h16v6H4z"/><path d="M9 7h6M9 17h6"/>
  </>),
  'su-connector': (<>
    <rect x="3" y="6" width="6" height="12" rx="1"/><path d="M9 12h6"/><rect x="15" y="6" width="6" height="12" rx="1"/>
  </>),
  'su-bag': (<>
    <path d="M5 5h14l-2 14H7z"/><path d="M9 9h6M9 13h6"/><path d="M11 5V3h2v2"/>
  </>),
  'tubing': (<>
    <path d="M3 12c3 0 3-3 6-3s3 6 6 6 3-3 6-3"/>
  </>),
  'filter-disk': (<>
    <circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5" fill="currentColor"/>
  </>),
  'su-bioreactor': (<>
    <rect x="6" y="3" width="12" height="6" rx="1"/><path d="M9 9v9a3 3 0 006 0V9"/><path d="M11 14h2"/>
  </>),
  'vial': (<>
    <path d="M9 2v6"/><path d="M15 2v6"/><path d="M5 8h14l-2 13H7L5 8z"/><path d="M8 14h8"/>
  </>),
  'flask': (<>
    <path d="M8 3h8v3l-2 3v9a2 2 0 01-2 2 2 2 0 01-2-2V9L8 6V3z"/>
  </>),
  'petri': (<>
    <circle cx="12" cy="9" r="6"/><path d="M9 14l-3 7h12l-3-7"/>
  </>),
  'pipette': (<>
    <path d="M11 2v8"/><path d="M9 10h6l1 4-2 8h-4l-2-8 1-4z"/><path d="M9.5 14h5"/>
  </>),
  'sensor-probe': (<>
    <circle cx="12" cy="6" r="3"/><path d="M12 9v9"/><path d="M9 18h6"/><path d="M9 21h6"/>
  </>),
  'su-mixer': (<>
    <rect x="3" y="9" width="18" height="6" rx="1"/><path d="M3 12h18" strokeDasharray="1 2"/><path d="M7 6v3M11 6v3M15 6v3"/>
  </>),
  'aseptic-port': (<>
    <circle cx="12" cy="12" r="3"/><path d="M12 3v6M12 15v6M3 12h6M15 12h6"/>
  </>),
  'tote': (<>
    <rect x="5" y="3" width="14" height="6" rx="1"/><path d="M7 9v9a2 2 0 002 2h6a2 2 0 002-2V9"/><path d="M9 13h6"/>
  </>),
  'cap-seal': (<>
    <circle cx="12" cy="12" r="9"/><path d="M3 9h18M3 15h18"/><path d="M12 3v18"/>
  </>),
  'cuvette': (<>
    <path d="M6 4h12v4H6z"/><path d="M7 8l1 13h8l1-13"/><path d="M10 12v6M14 12v6"/>
  </>),
  'tray': (<>
    <path d="M3 6h18"/><path d="M5 6v12h14V6"/><path d="M9 10v6M13 10v6"/>
  </>),
  'identity': (<>
    <path d="M4 8c4 0 4 8 8 8s4-8 8-8"/><path d="M4 16c4 0 4-8 8-8s4 8 8 8"/>
  </>),
  'potency': (<>
    <path d="M4 4l8 16 8-16"/><path d="M8 12h8"/>
  </>),
  'bioburden': (<>
    <circle cx="9" cy="9" r="2"/><circle cx="15" cy="11" r="1.5"/><circle cx="11" cy="14" r="2.5"/><circle cx="16" cy="16" r="1.2"/><circle cx="7" cy="14" r="1"/>
  </>),
  'endotoxin': (<>
    <path d="M8 3h8v6l-2 3v9h-4v-9L8 9z"/><path d="M9 12h6"/><path d="M12 4v3"/>
  </>),
  'ph-test': (<>
    <circle cx="12" cy="12" r="9"/><path d="M9 12c1-3 5-3 6 0"/><path d="M12 6v3"/>
  </>),
  'hplc': (<>
    <rect x="3" y="6" width="18" height="12" rx="1"/><path d="M3 12h18" strokeDasharray="1 2"/><path d="M7 9v6M11 9v6M15 9v6M19 9v6"/>
  </>),
  'spectro': (<>
    <path d="M3 18l6-7 4 5 8-9"/><path d="M21 7v4h-4"/>
  </>),
  'inspect': (<>
    <circle cx="11" cy="11" r="6"/><path d="M16 16l5 5"/><path d="M9 11h4M11 9v4"/>
  </>),
  'deviation': (<>
    <path d="M12 9v4M12 17h.01"/><path d="M10.3 3.86 1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
  </>),
  'capa': (<>
    <path d="M3 12a9 9 0 0115-6.7M21 4v5h-5"/><path d="M21 12a9 9 0 01-15 6.7M3 20v-5h5"/>
  </>),
  'batch-record': (<>
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6"/><path d="M9 13h6M9 17h4"/>
  </>),
  'review-ok': (<>
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6"/><path d="M9 14l2 2 4-5"/>
  </>),
  'release': (<>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/>
  </>),
  'oos-clock': (<>
    <circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/><path d="M3 3l3 3M21 3l-3 3"/>
  </>),
  'chain-custody': (<>
    <path d="M3 5h18l-9 8z"/><path d="M3 5v14h18V5"/><path d="M9 13l-3 6M15 13l3 6"/>
  </>),
};

export type WxbIconName = keyof typeof WxbIconsData;
